import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { TooltipGeneral } from "components/DesignComponents/Tooltips";
import { useOverflow } from "shared/hooks/useOverflow";
import { body2SemiBold } from "shared";

import { SingleDataItemProps } from "./types";

const SingleDataItem = ({
    name,
    data,
    icon,
    isRestricted,
    isFirstCentered
}: SingleDataItemProps) => {
    const { gray700, textDisabled, textPlaceholder } = colors;

    const { ref, isOverflowing } = useOverflow([data], true);

    return (
        <>
            <span
                css={[
                    body2SemiBold,
                    {
                        color: textPlaceholder,
                        wordBreak: "break-word",
                        display: "flex",
                        alignItems: isFirstCentered ? "center" : "unset"
                    }
                ]}
            >
                {icon}
                {name}:
            </span>

            <TooltipGeneral
                title={
                    <span
                        css={css({
                            display: "block",
                            maxHeight: "240px",
                            overflowY: "auto",
                            marginRight: "-16px",
                            paddingRight: "16px",

                            "&::-webkit-scrollbar-thumb": {
                                borderColor: gray700
                            }
                        })}
                    >
                        {data}
                    </span>
                }
                disableHoverListener={!isOverflowing}
                disableTouchListener
            >
                <span
                    ref={ref}
                    css={[
                        body2SemiBold,
                        {
                            color: isRestricted ? textDisabled : gray700,
                            wordBreak: "break-word",
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 10
                        }
                    ]}
                >
                    {data}
                </span>
            </TooltipGeneral>
        </>
    );
};

export default SingleDataItem;
